import { t } from 'i18next'

import type {
  PacingMetric,
  PacingStatus
} from '~/modules/retailMedia/services/campaign/spend-reports'

import styles from './styles.module.css'

const PACING_FILL_BLUE = '#3993f4'

const FORECAST_PROGRESS_FILL: Record<PacingStatus, string> = {
  critical_underpacing: '#f95d47',
  underpacing: '#e9c701',
  on_track: PACING_FILL_BLUE,
  overpacing: PACING_FILL_BLUE
}

export const PACING_CHIP_BG: Record<PacingStatus, string> = {
  overpacing: '#ffe0ae',
  on_track: '#cefdc0',
  underpacing: '#fbf7d4',
  critical_underpacing: '#ffdfd9'
}

export const formatMoney = (amount: number, currency: string) =>
  new Intl.NumberFormat('pt-BR', { style: 'currency', currency }).format(
    amount / 100
  )

export interface PacingCardProps {
  title: string
  metric: PacingMetric
  currency: string
  progressVariant: 'consumption' | 'forecast'
}

export const PacingCard = ({
  title,
  metric,
  currency,
  progressVariant
}: PacingCardProps) => {
  const progressFill =
    progressVariant === 'forecast'
      ? FORECAST_PROGRESS_FILL[metric.pacing]
      : PACING_FILL_BLUE

  return (
    <div className={styles.card}>
      <div className={styles.header}>
        <span className={styles.title} title={title}>
          {title}
        </span>
        <output
          className={styles.badge}
          style={{ background: PACING_CHIP_BG[metric.pacing] }}
        >
          {t(`rm:spendReport.pacing.${metric.pacing}`)}
        </output>
      </div>
      <div className={styles.body}>
        <div className={styles.valueRow}>
          <p
            className={styles.value}
            title={formatMoney(metric.value, currency)}
          >
            {formatMoney(metric.value, currency)}
          </p>
          <span className={styles.percentage}>
            {metric.percentage.toFixed(1)}%
          </span>
        </div>
        <div className={styles.progressTrack}>
          <div
            className={styles.progressFill}
            style={{
              width: `${Math.min(metric.percentage, 100)}%`,
              background: progressFill
            }}
          />
        </div>
      </div>
    </div>
  )
}

export { default, default as OverviewCards } from './OverviewCards'
export { default as PacingCardSkeleton } from './PacingCardSkeleton'
